<template>
  <transition name="fade">
    <div class="userModal" v-if="show">
      <div class="overlay" v-on:click="close(false)"></div>
      <div :class="{modalContent: true, modalBig: true}">
        <div class="close" v-on:click="close(false)"></div>
        <div class="payungB"></div><div class="leafL"></div>
        <h4>Video Inside Out</h4>
        <div class="liCnt">
          <div class="li" v-on:click="play1a">
            <div class="icon a1"></div> Nutrilite Mixed Collagen Bodykey
          </div>
          <div class="li" v-on:click="play2a">
            <div class="icon a2"></div> Nutrilite Mixed Collagen Drink
          </div>
          <div class="li" v-on:click="play3a">
            <div class="icon a3"></div> Nutrilite Orangeberry Collagen
          </div>
        </div>
      </div>
      <Video ref="video"/>
    </div>
  </transition>
</template>

<script>
import Video from '@/components/Video.vue';

export default {
  components: { Video },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    play1a() {
      this.$refs.video.open({
        title: 'mixed-collagen',
        sources: [
          {
            src: 'https://storage.googleapis.com/deepdivedjkt/clg/mixed-collagen-1080.mp4',
            type: 'video/mp4',
            size: 1080,
          },
          {
            src: 'https://storage.googleapis.com/deepdivedjkt/clg/mixed-collagen-720.mp4',
            type: 'video/mp4',
            size: 720,
          },
          {
            src: 'https://storage.googleapis.com/deepdivedjkt/clg/mixed-collagen-480.mp4',
            type: 'video/mp4',
            size: 480,
          },
          {
            src: 'https://storage.googleapis.com/deepdivedjkt/clg/mixed-collagen-360.mp4',
            type: 'video/mp4',
            size: 360,
          },
        ],
      });
    },
    play2a() {
      this.$refs.video.open({
        type: 'video',
        title: 'mixed-collagen-drink',
        sources: [
          {
            src: 'https://storage.googleapis.com/deepdivedjkt/clg/mixed-collagen-drink-1080.mp4',
            type: 'video/mp4',
            size: 1080,
          },
          {
            src: 'https://storage.googleapis.com/deepdivedjkt/clg/mixed-collagen-drink-720.mp4',
            type: 'video/mp4',
            size: 720,
          },
          {
            src: 'https://storage.googleapis.com/deepdivedjkt/clg/mixed-collagen-drink-480.mp4',
            type: 'video/mp4',
            size: 480,
          },
          {
            src: 'https://storage.googleapis.com/deepdivedjkt/clg/mixed-collagen-drink-360.mp4',
            type: 'video/mp4',
            size: 360,
          },
        ],
      });
    },
    play3a() {
      this.$refs.video.open({
        type: 'video',
        title: 'orangeberry-collagen',
        sources: [
          {
            src: 'https://storage.googleapis.com/deepdivedjkt/clg/orangeberry-collagen-1080.mp4',
            type: 'video/mp4',
            size: 1080,
          },
          {
            src: 'https://storage.googleapis.com/deepdivedjkt/clg/orangeberry-collagen-720.mp4',
            type: 'video/mp4',
            size: 720,
          },
          {
            src: 'https://storage.googleapis.com/deepdivedjkt/clg/orangeberry-collagen-480.mp4',
            type: 'video/mp4',
            size: 480,
          },
          {
            src: 'https://storage.googleapis.com/deepdivedjkt/clg/orangeberry-collagen-360.mp4',
            type: 'video/mp4',
            size: 360,
          },
        ],
      });
    },
    open(d, n) {
      this.show = true;
    },
    close(b, d) {
      this.show = false;
    },
  },
};
</script>

<style scoped lang="scss">
  .leafL{
    width: 280px; height: 280px;
    position: absolute;
    left: -100px; bottom: -96px;
    background-image: url(../assets/leaf-l.png);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 1;
  }

  .userModal{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9991;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: auto;
    padding: 40px 0;
    @media (max-width: 680px) {
      padding: 20px 10px;
    }
    .overlay{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
    }
    .modalContent{
      position: relative;
      z-index: 2;
      background: #ffe7ea;
      width: 260px;
      margin: auto;
      border-radius: 5px;
      padding: 40px 100px;
      overflow: hidden;
      transition: all .3s ease;
      .payungB{
        width: 160px; height: 160px;
        position: absolute;
        right: -100px; bottom: 40px;
        opacity: .6;
        background-image: url(../assets/umbrela-pink.png);
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        z-index: 7;
        // @media (max-width: 960px) {
        //   display: block;
        //   width: 240px; height: 240px;
        //   top: 50%; left: -140px; margin-top: -40px;
        // }
        // @media (max-width: 680px) {
        //   display: block;
        //   width: 140px; height: 140px;
        //   top: 50%; left: -80px; margin-top: -40px;
        // }
      }
      .close{
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-image: url(../assets/close.png);
        background-size: 14px auto;
        background-position: center;
        background-repeat: no-repeat;
        position: absolute;
        right: 10px;
        top: 10px;
        opacity: .4;
        cursor: pointer;
        transition: all .2s linear;
      }
      .close:hover{
        background-color: #e5e5e5;
        opacity: .7;
      }
      h4{
        margin: 0 0 20px;
        font-size: 16px;
        color: #ca7e8b;
      }
      .liCnt{
        margin: 0 -100px;
        position: relative;
        z-index: 9;
        .li{
          list-style: none;
          padding: 0 20px;
          padding-left: 120px;
          margin: 0 40px 10px;
          font-size: 17px;
          cursor: pointer;
          color: #444;
          transition: all .3s ease;
          position: relative;
          display: block;
          text-decoration: none;
          border-radius: 10px;
          background-color: #fff3f4;
          height: 100px;
          line-height: 1.3;
          padding-top: 26px;
          box-sizing: border-box;
          @media (max-width: 680px) {
            padding-left: 104px;
            margin: 0 20px 10px;
          }
          .icon{
            position: absolute;
            left: 20px; top: 10px; width: 80px; height: 80px;
            border-radius: 5px;
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;
            background-color: red;
            opacity: 1;
            @media (max-width: 680px) {
              left: 10px;
            }
            &:before{
              content: "";
              width: 40px; height: 40px;
              background-image: url(../assets/play.png);
              background-size: 30px auto;
              background-position: center;
              background-repeat: no-repeat;
              position: absolute;
              transition: all .3s ease;
              top: 50%; left: 50%;
              margin: -20px 0 0 -20px;
            }
            &.a1{
              background-image: url(../assets/1a.jpg);
            }
            &.a2{
              background-image: url(../assets/2a.jpg);
            }
            &.a3{
              background-image: url(../assets/3a.jpg);
            }
          }
          &:hover{
            background-color: #efd5d8;
          }
        }
      }
    }
  }
</style>
